module.exports = __webpack_public_path__ + "img/Caribbean_Meal_Pork.d902fa54.jpg";